module.exports = __webpack_public_path__ + "img/roraima.42c0a3ce.jpg";